
export default function SyracuseHero() {
  return (
    <section className="relative min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden pt-20 md:pt-28">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9df1ae5f5ac63336abba31e16a71e79e.jpg"
          alt="Home Damage Restoration in Syracuse Utah"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2 leading-tight">
          Home Damage Restoration
        </h1>
        <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-sky-400 mb-6 md:mb-8">
          in Syracuse, Utah
        </p>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-6 md:mb-8 max-w-3xl mx-auto px-2">
          24/7 Emergency Response for Syracuse Homes &amp; Businesses Near Antelope Island &amp; the Great Salt Lake
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
          <a
            href="tel:3853406632"
            className="w-full sm:w-auto text-center bg-sky-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold transition-all duration-200 hover:brightness-90 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-lg md:text-xl mr-2"></i>
            Call (385) 340-6632
          </a>
          <button
            onClick={() => {
              const element = document.getElementById('syracuse-contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="w-full sm:w-auto bg-white text-sky-600 px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold transition-all duration-200 hover:brightness-90 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </button>
        </div>
      </div>
    </section>
  );
}
